export default class DisabledPaymentRequestError extends Error {
    constructor() {
        super("DisabledPaymentRequestError");
    }
}
